export default "__VITE_ASSET__BJ1I3Xga__"